export function formatPrice(number) {
  const formatter = new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 2
  });

  return formatter.format(number);
}
